const isWww = window.location.href.includes('www');

//export const API_URL = "https://swopanything.girnarsoft.co.in/apis/";
//export const API_BASE_URL = "https://swopanything.girnarsoft.co.in/";
//export const CHAT_BASE_URL = "https://swopanything.girnarsoft.co.in:8012/";

export const API_URL = isWww ? "https://www.sellanything247.com/apis/" : "https://sellanything247.com/apis/";
export const API_BASE_URL = isWww ? "https://www.sellanything247.com/" : "https://sellanything247.com/";
export const CHAT_BASE_URL = isWww ? "https://www.sellanything247.com:8012/" : "https://sellanything247.com:8012/";


//export const API_URL = isWww ? "http://local.girnarsoftswop.com/apis/" : "http://local.girnarsoftswop.com/apis/";
//export const API_BASE_URL = isWww ? "http://local.girnarsoftswop.com/" : "http://local.girnarsoftswop.com/";
//export const CHAT_BASE_URL = isWww ? "http://local.girnarsoftswop.com/" : "http://local.girnarsoftswop.com/";
